import vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import territoriesCountriesQuery from '@/api/gql/_shared/territories/query/territories-countries.gql'
import territoriesStatesQuery from '@/api/gql/_shared/territories/query/territories-states.gql'

const isFetchingStatesMap = {}
let isFetchingCountries = false

export default {
  namespaced: true,
  state: {
    countries: [],
    statesByCountryIso: {},
  },

  getters: {
    shippingCountries: state => state.countries.filter(obj => obj.isShippingCountry),
    billingCountries: state => state.countries,
    getCountryById: state => countryId =>
      state.countries.find(({ id }) => id === countryId) || null,
    getCountryByIso: state => countryIso => state.countries.find(({ iso }) => iso === countryIso),
    getStatesByCountryIso: state => countryIso => state.statesByCountryIso[countryIso] || [],
  },

  mutations: {
    setCountries(state, countries) {
      state.countries = countries
    },
    addStatesByCountryIso(state, statesByCountryIso) {
      Object.keys(statesByCountryIso).forEach(iso => {
        vue.set(state.statesByCountryIso, iso, statesByCountryIso[iso])
      })
    },
  },

  actions: {
    async fetchCountries({ dispatch, state }) {
      if (isFetchingCountries) return
      if (state.countries.length > 0) return // don't refetch if already present
      isFetchingCountries = true
      const [error, result] = await to(client.query({ query: territoriesCountriesQuery }))
      isFetchingCountries = false
      if (error) throw error
      if (!result.data) throw new Error('Fetching countries failed')
      const { territories } = result.data
      dispatch('handleFetchData', { territories })
    },

    async fetchStates({ dispatch, getters }, countryIso) {
      if (isFetchingStatesMap[countryIso]) return
      const billingAddressCountryStates = getters.getStatesByCountryIso(countryIso)
      if (billingAddressCountryStates.length > 0) return // don't refetch if arleady present
      isFetchingStatesMap[countryIso] = true
      const [error, result] = await to(
        client.query({ query: territoriesStatesQuery, variables: { countryIso } })
      )
      isFetchingStatesMap[countryIso] = false
      if (error) throw error
      if (!result.data) throw new Error(`Fetching states for country "${countryIso}" failed`)
      const { territories } = result.data
      dispatch('handleFetchData', { territories, statesCountryIso: countryIso })
    },

    handleFetchData({ commit }, { territories, statesCountryIso }) {
      if (territories.countries) {
        commit('setCountries', territories.countries)
      }
      if (territories.states && statesCountryIso) {
        const statesByCountryIso = {
          [statesCountryIso]: territories.states,
        }
        commit('addStatesByCountryIso', statesByCountryIso)
      }
    },
  },
}
